import React from "react";
import SectionHeader from "../Sections/SectionHeader";
import ImageOval from "../Sections/ImageOval";
import "./LetsTalkLuxurySection.css";

export default function LetsTalkLuxurySection() {
  const images = [
    "/Home/hotel-lobby.png",
    "/Home/hotel-checkin.png",
    "/Home/hotel-frontdesk.png",
  ];

  return (
    <section className="talkLuxury-section">
      <SectionHeader
        title={`Let's Talk Luxury`}
        subtitle={`Transform Your Guest Experience. Let’s automate your brand’s next chapter.`}
      />

      <div className="talkLuxury-buttons">
        <button className="outline talkLuxury-btn">Explore Agents</button>
        <button className="talkLuxury-btn filled">Book a Demo</button>
      </div>

      <ImageOval images={images} direction="left" />
      <ImageOval images={images} direction="right" />
    </section>
  );
}
